import { all, call, put, takeEvery } from 'redux-saga/effects';
import { actionType } from './action';
import { IAction } from '@/interface/IAction';
import { execSafeSaga } from '@lib/helpers';
import Auth from '@aws-amplify/auth';
import { userPrincipalParser } from '@/auth/cognito.service';
import { updateLocale } from '@/auth/cognito.service'

function* getUserPrincipalSaga() {
    const profile = yield call([Auth, 'currentSession']);
    yield put({ type: actionType.SET_USER_PRINCIPAL, payload: { profile: userPrincipalParser(profile) } });
}

function* updateUserLanguageSaga(action: IAction) {
    yield execSafeSaga(function* () {
        const { payload } = action;
        yield call(updateLocale, payload)
    });
}

function* rootSaga() {
    yield all([
        takeEvery(actionType.GET_USER_PRINCIPAL, getUserPrincipalSaga),
        takeEvery(actionType.UPDATE_LANGUAGE, updateUserLanguageSaga),
    ])
}

export default rootSaga;